import type { ReactNode } from 'react';

type ResolveCloseRefundButtonParams = {
    refundStatus?: string;
    refundReason?: string;
    visibleDoRefundMethod: boolean;
    refundDetails: any;
    closeRefundButton: (onClick: () => void) => ReactNode;
    onCompleteAndConfirmReturn: () => void;
    onDoRefund: () => void;
};

export const resolveCloseRefundButtonContent = ({
    refundStatus,
    refundReason,
    visibleDoRefundMethod,
    refundDetails,
    closeRefundButton,
    onCompleteAndConfirmReturn,
    onDoRefund,
}: ResolveCloseRefundButtonParams) => {
    const isForceDoRefundPendings = !!refundDetails?.isForceDoRefundPendings;

    if (refundStatus === 'IncludedToPetition') {
        if (refundReason === 'Return' && !isForceDoRefundPendings) {
            return closeRefundButton(onCompleteAndConfirmReturn);
        }
        return closeRefundButton(onDoRefund);
    }

    if (refundStatus !== 'IncludedToPetition' && visibleDoRefundMethod && refundReason === 'Return' && !isForceDoRefundPendings) {
        return refundDetails.enableCloseRefundButton
            ? closeRefundButton(onCompleteAndConfirmReturn)
            : null;
    }

    return refundDetails.enableCloseRefundButton ? closeRefundButton(onDoRefund) : null;
};
